import { useState } from 'react'
import classNames from 'classnames'

import ApplyStepButtons from 'components/ApplyStepButtons'
import ApplyStepIcon from 'components/ApplyStepIcon'

import s from './ApplyOpenCallRequirements.module.css'

function toCamelCase(str) {
  return str
    .split(' ')
    .map((word, index) => {
      if (index === 0) return word.toLowerCase()
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    .join('')
}

//TODO: setup proptypes
function ApplyOpenCallRequirements({ requirements, onSubmit }) {
  const [error, setError] = useState(false)
  const initalFieldValues = {}
  requirements.forEach((r) => {
    initalFieldValues[toCamelCase(r.title)] = false
  })
  const [fieldValues, setFieldValues] = useState(initalFieldValues)

  const handleChange = (attr, e) => {
    const fields = { ...fieldValues }
    fields[attr] = e.target.checked
    setError(false)
    setFieldValues(fields)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const uncheckedBoxes = requirements.filter(
      (r) => !fieldValues[toCamelCase(r.title)]
    )
    if (uncheckedBoxes.length === 0) {
      onSubmit(fieldValues)
    } else {
      setError(true)
    }
  }

  return (
    <div className={s.container}>
      <form onSubmit={handleSubmit}>
        <h1 className={s.title}>Requirements</h1>
        <p className={s.text}>
          Please confirm {`you've`} read and match the following criteria.
        </p>
        {requirements && (
          <div className={s.columns}>
            <div className={s.column}>
              {requirements
                .slice(0, Math.ceil(requirements.length / 2))
                .map((requirement, index) => (
                  <label key={requirement.title} className={s.requirement}>
                    <span className={s.requirementTitle}>
                      {requirement.title}
                    </span>
                    <span className={s.requirementDescription}>
                      {requirement.description}
                    </span>
                    <input
                      type="checkbox"
                      className={s.checkbox}
                      name={`requirement_${index}`}
                      value={requirement.title}
                      checked={
                        fieldValues[toCamelCase(requirement.title)] === true
                      }
                      onChange={(e) =>
                        handleChange(toCamelCase(requirement.title), e)
                      }
                    />
                    <span className={s.checkboxIcon} />
                  </label>
                ))}
            </div>
            <div className={s.column}>
              {requirements
                .slice(Math.ceil(requirements.length / 2))
                .map((requirement, index) => (
                  <label key={requirement.title} className={s.requirement}>
                    <span className={s.requirementTitle}>
                      {requirement.title}
                    </span>
                    <span className={s.requirementDescription}>
                      {requirement.description}
                    </span>
                    <input
                      type="checkbox"
                      className={s.checkbox}
                      name={`requirement_${index}`}
                      value={requirement.title}
                      checked={fieldValues[toCamelCase(requirement.title)]}
                      onChange={(e) =>
                        handleChange(toCamelCase(requirement.title), e)
                      }
                    />
                    <span className={s.checkboxIcon} />
                  </label>
                ))}
            </div>
          </div>
        )}
        {error && (
          <p className={classNames(s.text, s.error)}>
            You must fulfill all criteria
          </p>
        )}
        <ApplyStepButtons back="/apply/open-call" />
      </form>
      <ApplyStepIcon step="1" />
    </div>
  )
}

export default ApplyOpenCallRequirements
